import React, { Component } from 'react';
import PropTypes from 'prop-types';
import UserDashboard from '../../components/UserDashboard';
import { connect } from 'react-redux';
// import { ContentV2 } from '../../components';
// import ContentV3 from '../../components/ContentV3';

class Portal extends Component {

  componentDidMount() {
    const { location, history } = this.props;
    const pathNameArray = location.pathname.split('/');
    if(location.pathname.includes('code')) {
      location.pathname.split('=')[1].split('#')[0];
    }
    if(!pathNameArray[pathNameArray.length -1].includes('portal')) {
      history.push('/portal')
    }

  }


  render() {

    // const { /*companyDetails,companyBrandingDetails,*/companyDetails } = this.props;
    

    // const ShowNewUserDashboard = companyBrandingDetails?.allowed_new_user_dashboard;

    // const isWoliba =
    // companyDetails?.id === 1 &&
    // companyDetails?.company_name === "Woliba";

    // const isWolibaAndTestCompany =
    // companyDetails?.id === 1 ||
    // companyDetails?.id === 18 || companyDetails?.id === 176 ;


    return (
      <div>
        {/* { ShowNewUserDashboard ? (
          <UserDashboard history={this.props.history} companyDetails={companyDetails}/>)
          : (<ContentV2 history={this.props.history} check={this.props.check}/>)} */}
        <UserDashboard history={this.props.history} />
       
        
      </div>
    )
  }
}

Portal.propTypes = {
  location: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  check: PropTypes.bool.isRequired,
  // companyDetails: PropTypes.object.isRequired,
  // companyBrandingDetails: PropTypes.object.isRequired,
};


// const mapStateToProps = (state) => ({
//   companyDetails: state.profileData.companyDetails,
//   companyBrandingDetails: state.wellnessDashboard.companyBrandingDetails,
// });

export default connect(null)(Portal);



